
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/nonprofit",
      function () {
        return require("private-next-pages/use-cases/nonprofit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/nonprofit"])
      });
    }
  